import { useState, useEffect, useRef } from "react";
import "../styles/Header.css";
import logo from "../assets/img/logo.png";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function Header() {
    const [open, setOpen] = useState(false);
    const headerRef = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => (document.body.style.overflow = "");
    }, [open]);

    useEffect(() => {
        const handleDocClick = (e) => {
            if (e.target.closest(".gl-burger")) return;
            if (menuRef.current && menuRef.current.contains(e.target)) return;
            setOpen(false);
        };
        if (open) {
            document.addEventListener("click", handleDocClick);
        }
        return () => document.removeEventListener("click", handleDocClick);
    }, [open]);

    return (
        <header ref={headerRef} className={`gl-header ${open ? "menu-open" : ""}`}>
            <div className="gl-container">
                <a href="/" className="gl-logo">
                    <div className="gl-logo-wrap">
                        <img src={logo} alt="GL" />
                    </div>
                </a>

                <nav className="gl-nav" aria-label="Navigazione principale">
                    <a href="/" className="gl-link">Home</a>
                    <a href="/about-me" className="gl-link">Chi sono</a>
                    <div className="gl-dropdown" tabIndex={0}>
                        <button className="gl-link gl-dropdown-trigger" aria-haspopup="menu" aria-expanded="false">
                            Servizi <span className="chev" aria-hidden>▾</span>
                        </button>
                        <div className="gl-dropdown-menu" role="menu">
                            <a href="/kick-off-performance" role="menuitem">Kick-off Performance</a>
                            <a href="/restart-method" role="menuitem">Restart Method</a>
                        </div>
                    </div>
                    <a href="/contacts" className="gl-link">Contatti</a>
                    <div className="gl-socials" aria-label="Social">
                        <a href="https://www.linkedin.com/in/giammarco-lamanda-a9323a178/" aria-label="LinkedIn"><FaLinkedin size={20} /></a>
                        <a href="https://www.instagram.com/thefueldoctor/" aria-label="Instagram"><FaInstagram size={20} /></a>
                        <a href="mailto:lamanda.nutrizionista@gmail.com" aria-label="Email"><MdEmail size={20} /></a>
                    </div>
                </nav>

                <button
                    className={`gl-burger ${open ? "is-open" : ""}`}
                    aria-label="Apri menu"
                    aria-expanded={open}
                    aria-controls="gl-mobile-menu"
                    onClick={() => setOpen((v) => !v)}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>

            {open && <div className="gl-overlay" onClick={() => setOpen(false)} />}

            <nav
                id="gl-mobile-menu"
                ref={menuRef}
                className={`gl-nav-mobile ${open ? "show" : ""}`}
                aria-label="Menu mobile"
            >
                <a onClick={() => setOpen(false)} href="/">Home</a>
                <a onClick={() => setOpen(false)} href="/about-me">Chi sono</a>
                <details>
                    <summary>Servizi</summary>
                    <a onClick={() => setOpen(false)} href="/kick-off-performance">Kick-off Performance</a>
                    <a onClick={() => setOpen(false)} href="/restart-method">Restart Method</a>
                </details>
                <a onClick={() => setOpen(false)} href="/contacts">Contatti</a>
            </nav>
        </header>
    );
}